/**
 * Blog Carousel - JavaScript
 * Handles Swiper initialization and responsive behavior
 * Consistent with collection-carousel.js patterns
 */

(function() {
  'use strict';

  var swiperInstances = new Map();

  /**
   * Initialize a blog carousel
   */
  function initBlogCarousel(sectionElement) {
    var sectionId = sectionElement.dataset.sectionId;

    // Prevent double initialization on the same DOM element
    if (sectionElement._blogCarouselInitialized) {
      return;
    }

    var carouselElement = sectionElement.querySelector('[data-blog-carousel-swiper]');
    if (!carouselElement) {
      return;
    }

    var carouselKey = sectionId + '-blog-carousel';

    // Check if already in instances map
    if (swiperInstances.has(carouselKey)) {
      return swiperInstances.get(carouselKey);
    }

    var totalSlides = carouselElement.querySelectorAll('.swiper-slide').length;

    var swiperConfig = {
      // Responsive breakpoints - Blog cards are larger than collection cards
      breakpoints: {
        // Mobile: 1.15 slides visible (peek-through)
        320: {
          slidesPerView: 1.15,
          slidesPerGroup: 1,
          spaceBetween: 16,
          centeredSlides: false
        },
        // Tablet: 2.2 slides visible
        768: {
          slidesPerView: 2.2,
          slidesPerGroup: 2,
          spaceBetween: 16,
          centeredSlides: false
        },
        // Laptop: 3.2 slides visible
        1025: {
          slidesPerView: 3.2,
          slidesPerGroup: 2,
          spaceBetween: 20,
          centeredSlides: false
        },
        // Large screen: 3.5 slides visible
        1400: {
          slidesPerView: 3.5,
          slidesPerGroup: 2,
          spaceBetween: 24,
          centeredSlides: false
        }
      },

      // Performance & tracking
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,

      // Touch & drag settings
      simulateTouch: true,
      allowTouchMove: true,
      touchRatio: 1,
      resistance: true,
      resistanceRatio: 0.85,
      threshold: 5,
      followFinger: true,
      shortSwipes: true,
      longSwipes: true,
      touchEventsTarget: 'container',

      // Layout
      centeredSlides: false,
      updateOnWindowResize: true,
      resizeObserver: true,

      // Navigation (inside swiper container, same as collection-carousel)
      navigation: {
        nextEl: carouselElement.querySelector('.swiper-button-next'),
        prevEl: carouselElement.querySelector('.swiper-button-prev')
      },

      // Transitions
      speed: 600,
      cssMode: false,

      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous article',
        nextSlideMessage: 'Next article'
      },

      // Events
      on: {
        init: function() {
          updateNavVisibility(this, carouselElement, totalSlides);
        },
        breakpoint: function() {
          updateNavVisibility(this, carouselElement, totalSlides);
        },
        resize: function() {
          updateNavVisibility(this, carouselElement, totalSlides);
        }
      }
    };

    var blogSwiper = new Swiper(carouselElement, swiperConfig);
    swiperInstances.set(carouselKey, blogSwiper);
    sectionElement._blogCarouselInitialized = true;
  }

  /**
   * Update navigation button visibility
   * Hide when all slides fit in the viewport
   */
  function updateNavVisibility(swiperInstance, carouselElement, totalSlides) {
    var prevBtn = carouselElement.querySelector('.swiper-button-prev');
    var nextBtn = carouselElement.querySelector('.swiper-button-next');

    if (!prevBtn || !nextBtn || !swiperInstance) return;

    var currentSlidesPerView = swiperInstance.params.slidesPerView;

    if (totalSlides <= Math.floor(currentSlidesPerView)) {
      prevBtn.style.setProperty('display', 'none', 'important');
      nextBtn.style.setProperty('display', 'none', 'important');
    } else {
      prevBtn.style.removeProperty('display');
      nextBtn.style.removeProperty('display');
    }
  }

  /**
   * Initialize all blog carousels on the page
   */
  function initAll() {
    var sections = document.querySelectorAll('[data-section-type="blog-carousel"]');
    sections.forEach(function(section) {
      initBlogCarousel(section);
    });
  }

  /**
   * Cleanup all instances
   */
  function cleanupAll() {
    swiperInstances.forEach(function(swiper, key) {
      swiper.destroy(true, false);
    });
    swiperInstances.clear();

    var sections = document.querySelectorAll('[data-section-type="blog-carousel"]');
    sections.forEach(function(section) {
      section._blogCarouselInitialized = false;
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('[data-section-type="blog-carousel"]');
      if (section) {
        initBlogCarousel(section);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target.querySelector('[data-section-type="blog-carousel"]');
      if (section) {
        var sectionId = section.dataset.sectionId;
        var carouselKey = sectionId + '-blog-carousel';

        if (swiperInstances.has(carouselKey)) {
          swiperInstances.get(carouselKey).destroy(true, false);
          swiperInstances.delete(carouselKey);
          section._blogCarouselInitialized = false;
        }
      }
    });

    document.addEventListener('shopify:section:reorder', function() {
      cleanupAll();
      initAll();
    });
  }

  // Handle window resize (debounced)
  var resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      swiperInstances.forEach(function(swiper) {
        if (swiper && swiper.update) {
          swiper.update();
        }
      });
    }, 250);
  });

  // Cleanup on page unload
  window.addEventListener('beforeunload', cleanupAll);

})();
